import React, { Component } from "react";
import {
  Button,
  Modal,
  TextField,
  Fade,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import JoditEditor from "jodit-react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Backdrop from "@mui/material/Backdrop";
import ClearIcon from "@mui/icons-material/Clear";
import Autocomplete from "@mui/material/Autocomplete";
import { ToastContainer, toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import { VariablLightSvg } from "../CommonSvgs";
import Tooltip from "@mui/material/Tooltip";

const editorData = [
  // {
  //   id: 4,
  //   type: "no",
  //   text: "Email Ai",
  // },
  {
    id: 5,
    type: "no",
    text: "Unsubscribe link",
  },
  {
    id: 6,
    type: "no",
    text: "Calendly link",
  },
  {
    id: 7,
    type: "no",
    text: "Insert Image",
  },
  {
    id: 8,
    type: "no",
    text: "Insert Link",
  },
  // {
  //   id: 9,
  //   type: "no",
  //   text: "Spam Check",
  // },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 5000000,
};
const vikki = [
  "Access,Access now,Act,Act immediately,Act now,Act now!,Action,Action required,Apply here,Apply now,Apply now!,Apply online,Become a member,Before it's too late,Being a member,Buy,Buy direct,Buy now,Buy today,Call,Call free,Call free/now,Call me,Call now,Call now!,Can we have a minute of your time?,Cancel now,Cancellation required,Claim now,Click,Click below,Click here,Click me to download,Click now,Click this link,Click to get,Click to remove,Contact us immediately,Deal ending soon,Do it now,Do it today,Don't delete,Don't hesitate,Don't waste time,Don't delete,Exclusive deal,Expire,Expires today,Final call,For instant access,For Only,For you,Friday before [holiday],Get it away,Get it now,Get now,Get paid,Get started,Get started now,Great offer,Hurry up,Immediately,Info you requested,Information you requested,Instant,Limited time,New customers only,Now,Now only,Offer expires,Once in lifetime,Only,Order now,Order today,Please read,Purchase now,Sign up free,Sign up free today,Supplies are limited,Take action,Take action now,This won't last,Time limited,Today,Top urgent,Trial,Urgent,What are you waiting for?,While supplies last,You are a winner,0 down,All,All natural,All natural/new,All new,All-natural,All-new,Allowance,As seen on,As seen on Oprah,At no cost,Auto email removal,Avoice bankruptcy,Avoid,Beneficial offer,Beneficiary,Bill 1618,Brand new pager,Bulk email,Buying judgements,Buying judgments,Cable converter,Calling creditors,Can you help us?,Cancel at any time,Cannot be combined,Celebrity,Cell phone cancer scam,Certified,Chance,Cheap,Cheap meds,Cialis,Claims,Claims not to be selling anything,Claims to be in accordance with some spam law,Claims to be legal,Clearance,Collect,Collect child support,Compare,Compare now,Compare online,Compare rates,Compete for your business,Confidentiality,Congratulations,Consolidate debt and credit,Consolidate your debt,Copy accurately,Copy DVDs,COVID,Cures,Cures baldness,Diagnostic,DIAGNOSTICS,Diet,Dig up dirt on friends,Direct email,Direct marketing,Eliminate debt,Explode your business,Fast viagra delivery,Finance,Financial,Financial advice,Financial independence,Financially independent,For new customers only,Foreclosure,Free,Free access/money/gift,Free bonus,Free cell phone,Free DVD,Free grant money,Free information,Free installation,Free Instant,Free iPhone,Free laptop,Free leads,Free Macbook,Free offer,Free priority mail,Free sample,Free website,Free!,Get,Gift card,Gift certificate,Gift included,Give it away,Giving away,Giving it away,Gold,Great,Great deal,Greetings of the day,Growth hormone,Guarantee,Guaranteed deposit,Guaranteed income,Guaranteed payment,Have you been turned down?,Hello (with no name included),Hidden charges,Hidden costs,Hidden fees,High score,Home based business,Home mortgage,Human,Human growth hormone,If only it were that easy,Important information,Important notification,Instant weight loss,Insurance Lose weight,Internet marketing,Investment decision,Invoice,It's effective,Job alert,Junk,Lambo,Laser printer,Last Day,Legal,Legal notice,Life,Life insurance,Lifetime access,Lifetime deal,Limited,Limited amount,Limited number,Limited offer,Limited supply,Limited time offer,Limited time only,Loan,Long distance phone number,Long distance phone offer,Lose weight,Lose weight fast,Lose weight spam,Lottery,Lower interest rate,Lower interest rates,Lower monthly payment,Lower your mortgage rate,Lowest insurance rates,Lowest interest rate,Lowest rate,Lowest rates,Luxury,Luxury car,Mail in order form,Main in order form,Mark this as not junk,Mass email,Medical,Medicine,Meet girls,Meet me,Meet singles,Meet women,Member,Member stuff,Message contains disclaimer,Message from,Millionaire,Millions,MLM,Multi-level marketing,Name,Near you,Never before,New,New domain extensions,Nigerian,No age restrictions,No catch,No claim forms,No cost,No credit check,No credit experience,No deposit required,No disappointment,No experience,No fees,No gimmick,No hidden,No hidden costs,No hidden fees,No hidden сosts,No interest,No interests,No inventory,No investment,No investment required,No medical exams,No middleman,No obligation,No payment required,No purchase necessary,No questions asked,No selling,No strings attached,No-obligation,Nominated bank account,Not intended,Not junk,Not scam,Not spam,Notspam,Number 1,Obligation,Off,Off everything,Off shore,Offer extended,Offers,Offshore,One hundred percent,One-time,Online biz opportunity,Online degree,Online income,Online job,Open,Opportunity,Opt-in,Order,Order shipped by,Order status,Orders shipped by,Orders shipped by shopper,Outstanding value,Outstanding values,Password,Passwords,Pay your bills,Per day/per week/per year,Per month,Perfect,Performance,Phone,Please,Please open,Presently,Print form signature,Print from signature,Print out and fax,Priority mail,Privately owned funds,Prizes,Problem with shipping,Problem with your order,Produced and sent out,Profit,Promise you,Purchase,Pure Profits,Quotes,Rate,Real thing,Rebate,Reduce debt,Refinance home,Refinanced home,Refund,Regarding,Removal instructions,Removes,Removes wrinkles,Replica watches,Request,Request now,Request today,Requires initial investment,Requires investment,Reverses aging,Risk free,Rolex,Round the world,S 1618,Safeguard notice,Sale,Sales,Save,Save $, Save €,Save big,Save big month,Save money,Save now,Score with babes,Search engine optimisation,Section 301,See for yourself,Seen on,Serious,Serious case,Serious offer,Serious only,Sex,Shop now,Shopper,Shopping spree,Snoring,Social security number,Soon,Spam,Spam free,Special deal,Special discount,Special for you,Special offer,Stainless steel,Stock alert,Stock disclaimer statement,Stock pick,Stocks/stock pick/stock alert,Stop calling me,Stop emailing me,Stop further distribution,Stop snoring,Strong buy,Stuff on sale,Subject to,Subject to cash,Subscribe,Subscribe for free,Subscribe now,Super promo,Supplies,Tack action now,Talks about hidden charges,Talks about prizes,Tells you it's an ad,Terms,The best rates,The email asks for a credit card,The following form,They make a claim or claims that they're in accordance with spam law,They try to keep your money no refund,They're just giving it away,This isn't junk,This isn't spam,This isn't a scam,This isn't junk,This isn't spam,Timeshare,Timeshare offers,Traffic,Trial unlimited,U.S. dollars,Undisclosed,Undisclosed recipient,University diplomas,Unsecured credit,Unsecured debt,Unsolicited,Unsubscribe,Urgent response,US dollars / Euros,Vacation,Vacation offers,Valium,Viagra,Vicodin,VIP,Visit our website,Wants credit card,Warranty expired,We hate spam,We honor all,Website visitors,Weekend getaway,Weight loss,What's keeping you?,While available,While in stock,While stocks last,While you sleep,Who really wins?,Win,Winner,Winning,Won,Xanax,XXX,You have been chosen,You have been selected,Your chance,Your status,Zero chance,Zero percent,Zero risk,#1,%,% free,% Satisfied,0%,0% risk,100%,100% free,100% more,100% off,100% satisfied,99.90%,99%,Access for free,Additional income,Amazed,Amazing,Amazing offer,Amazing stuff,Be amazed,Be surprised,Be your own boss,Believe me,Best bargain,Best deal,Best offer,Best price,Best rates,Big bucks,Bonus,Boss,Can't live without,Cancel,Consolidate debt,Double your cash,Double your income,Drastically reduced,Earn extra cash,Earn money,Eliminate bad credit,Expect to earn,Extra,Extra cash,Extra income,Fantastic,Fantastic deal,Fantastic offer,FAST,Fast cash,Financial freedom,Free access,Free consultation,Free gift,Free hosting,Free info,Free investment,Free membership,Free money,Free preview,Free quote,Free trial,Full refund,Get out of debt,Giveaway,Guaranteed,Increase sales,Increase traffic,Incredible deal,Join billions,Join millions,Join millions of Americans,Join thousands,Lower rates,Lowest price,Make money,Million,Million dollars,Miracle,Money back,Month trial offer,More Internet Traffic,Number one,Once in a lifetime,One hundred percent guaranteed,One time,Pennies a day,Potential earnings,Prize,Promise,Pure profit,Risk-free,Satisfaction guaranteed,Save big money,Save up to,Special promotion,The best,Thousands,Unbeatable offer,Unbelievable,Unlimited,Unlimited trial,Wonderful,You will not believe your eyes,$$$,€€€,£££,50% off,A few bob,Accept cash cards,Accept credit cards,Affordable,Affordable deal,Avoid bankruptcy,Bad credit,Bank,Bankruptcy,Bargain,Billing,Billing address,Billion,Billion dollars,Billionaire,Card accepted,Cards accepted,Cash,Cash bonus,Cash out,Cash-out,Cashcashcash,Casino,Cents on the dollar,Check,Check or money order,Claim your discount,Cost,Costs,Credit,Credit bureaus,Credit card,Credit card offers,Credit or Debit,Deal,Debt,Discount,Dollars,Double your,Double your wealth,Earn,Earn $,Earn cash,Earn extra income,Earn from home,Earn monthly,Earn per month,Earn per week,Earn your degree,Easy income,Easy terms,F r e e,For free,For just $,For just $ (amount),For just $xxx,Get Money,Get your money,Hidden assets,Huge discount,Income,Income from home,Increase revenue,Increase sales/traffic,Increase your chances,Initial investment,Instant earnings,Instant income,Insurance,Investment,Investment advice,Lifetime,Loans,Make $,,Money making,Money-back guarantee,Money-making,Monthly payment,Mortgage,Mortgage rates,Offer,One hundred percent free,Only $,Price,Price protection,Prices,Profits,Quote,Rates,Refinance,Save $,Serious cash,Subject to credit,US dollars,Why pay more?,Your income,Acceptance,Accordingly,Account-based marketing (ABM),Accounts,Addresses,Addresses on CD,Beverage,Confidentiality on all orders,Confidentially on all orders,Content marketing,Dear [email address],Dear [email/friend/somebody],Dear [first name],Dear [wrong name],Digital marketing,Dormant,Email extractor,Email harvest,Email marketing,Extract email,Form,Freedom,Friend,Here,Hidden,Home,Home based,Home employment,Home-based,Home-based business,Homebased business,If you no longer wish to receive,Important information regarding,In accordance with laws,Increase your sales,Internet market,Leave,Lose,Maintained,Marketing,Marketing solution,Marketing solutions,Medium,Message contains,Multi level marketing,Never,One time mailing,Online marketing,Online pharmacy,Opt in,Per day,Per week,Pre-approved,Problem,Removal,Remove,Reserves the right,Reverses,Sample,Satisfaction,Score,Search engine,Search engine listings,Search engines,Sent in compliance,Solution,Stop,Success,Teen,Terms and conditions,Warranty,Web traffic,Wife,Work at home,Work from home",
];
const vikki3 = [
  "Access",
  "Access now",
  "Act",
  "Act immediately",
  "Act now",
  "Act now!",
  "Action",
  "Action required",
  "Apply here",
  "Apply now",
  "Apply now!",
  "Apply online",
  "Become a member",
  "Before it's too late",
  "Being a member",
  "Buy",
  "Buy direct",
  "Buy now",
  "Buy today",
  "Call",
  "Call free",
  "Call free/now",
  "Call me",
  "Call now",
  "Call now!",
  "Can we have a minute of your time?",
  "Cancel now",
  "Cancellation required",
  "Claim now",
  "Click",
  "Click below",
  "Click here",
  "Click me to download",
  "Click now",
  "Click this link",
  "Click to get",
  "Click to remove",
  "Contact us immediately",
  "Deal ending soon",
  "Do it now",
  "Do it today",
  "Don't delete",
  "Don't hesitate",
  "Don't waste time",
  "Don't delete",
  "Exclusive deal",
  "Expire",
  "Expires today",
  "Final call",
  "For instant access",
  "For Only",
  "For you",
  "Friday before [holiday]",
  "Get it away",
  "Get it now",
  "Get now",
  "Get paid",
  "Get started",
  "Get started now",
  "Great offer",
  "Hurry up",
  "Immediately",
  "Info you requested",
  "Information you requested",
  "Instant",
  "Limited time",
  "New customers only",
  "Now",
  "Now only",
  "Offer expires",
  "Once in lifetime",
  "Only",
  "Order now",
  "Order today",
  "Please read",
  "Purchase now",
  "Sign up free",
  "Sign up free today",
  "Supplies are limited",
  "Take action",
  "Take action now",
  "This won't last",
  "Time limited",
  "Today",
  "Top urgent",
  "Trial",
  "Urgent",
  "What are you waiting for?",
  "While supplies last",
  "You are a winner",
  "0 down",
  "All",
  "All natural",
  "All natural/new",
  "All new",
  "All-natural",
  "All-new",
  "Allowance",
  "As seen on",
  "As seen on Oprah",
  "At no cost",
  "Auto email removal",
  "Avoice bankruptcy",
  "Avoid",
  "Beneficial offer",
  "Beneficiary",
  "Bill 1618",
  "Brand new pager",
  "Bulk email",
  "Buying judgements",
  "Buying judgments",
  "Cable converter",
  "Calling creditors",
  "Can you help us?",
  "Cancel at any time",
  "Cannot be combined",
  "Celebrity",
  "Cell phone cancer scam",
  "Certified",
  "Chance",
  "Cheap",
  "Cheap meds",
  "Cialis",
  "Claims",
  "Claims not to be selling anything",
  "Claims to be in accordance with some spam law",
  "Claims to be legal",
  "Clearance",
  "Collect",
  "Collect child support",
  "Compare",
  "Compare now",
  "Compare online",
  "Compare rates",
  "Compete for your business",
  "Confidentiality",
  "Congratulations",
  "Consolidate debt and credit",
  "Consolidate your debt",
  "Copy accurately",
  "Copy DVDs",
  "COVID",
  "Cures",
  "Cures baldness",
  "Diagnostic",
  "DIAGNOSTICS",
  "Diet",
  "Dig up dirt on friends",
  "Direct email",
  "Direct marketing",
  "Eliminate debt",
  "Explode your business",
  "Fast viagra delivery",
  "Finance",
  "Financial",
  "Financial advice",
  "Financial independence",
  "Financially independent",
  "For new customers only",
  "Foreclosure",
  "Free",
  "Free access/money/gift",
  "Free bonus",
  "Free cell phone",
  "Free DVD",
  "Free grant money",
  "Free information",
  "Free installation",
  "Free Instant",
  "Free iPhone",
  "Free laptop",
  "Free leads",
  "Free Macbook",
  "Free offer",
  "Free priority mail",
  "Free sample",
  "Free website",
  "Free!",
  "Get",
  "Gift card",
  "Gift certificate",
  "Gift included",
  "Give it away",
  "Giving away",
  "Giving it away",
  "Gold",
  "Great",
  "Great deal",
  "Greetings of the day",
  "Growth hormone",
  "Guarantee",
  "Guaranteed deposit",
  "Guaranteed income",
  "Guaranteed payment",
  "Have you been turned down?",
  "Hello (with no name included)",
  "Hidden charges",
  "Hidden costs",
  "Hidden fees",
  "High score",
  "Home based business",
  "Home mortgage",
  "Human",
  "Human growth hormone",
  "If only it were that easy",
  "Important information",
  "Important notification",
  "Instant weight loss",
  "Insurance Lose weight",
  "Internet marketing",
  "Investment decision",
  "Invoice",
  "It's effective",
  "Job alert",
  "Junk",
  "Lambo",
  "Laser printer",
  "Last Day",
  "Legal",
  "Legal notice",
  "Life",
  "Life insurance",
  "Lifetime access",
  "Lifetime deal",
  "Limited",
  "Limited amount",
  "Limited number",
  "Limited offer",
  "Limited supply",
  "Limited time offer",
  "Limited time only",
  "Loan",
  "Long distance phone number",
  "Long distance phone offer",
  "Lose weight",
  "Lose weight fast",
  "Lose weight spam",
  "Lottery",
  "Lower interest rate",
  "Lower interest rates",
  "Lower monthly payment",
  "Lower your mortgage rate",
  "Lowest insurance rates",
  "Lowest interest rate",
  "Lowest rate",
  "Lowest rates",
  "Luxury",
  "Luxury car",
  "Mail in order form",
  "Main in order form",
  "Mark this as not junk",
  "Mass email",
  "Medical",
  "Medicine",
  "Meet girls",
  "Meet me",
  "Meet singles",
  "Meet women",
  "Member",
  "Member stuff",
  "Message contains disclaimer",
  "Message from",
  "Millionaire",
  "Millions",
  "MLM",
  "Multi-level marketing",
  "Name",
  "Near you",
  "Never before",
  "New",
  "New domain extensions",
  "Nigerian",
  "No age restrictions",
  "No catch",
  "No claim forms",
  "No cost",
  "No credit check",
  "No credit experience",
  "No deposit required",
  "No disappointment",
  "No experience",
  "No fees",
  "No gimmick",
  "No hidden",
  "No hidden costs",
  "No hidden fees",
  "No hidden сosts",
  "No interest",
  "No interests",
  "No inventory",
  "No investment",
  "No investment required",
  "No medical exams",
  "No middleman",
  "No obligation",
  "No payment required",
  "No purchase necessary",
  "No questions asked",
  "No selling",
  "No strings attached",
  "No-obligation",
  "Nominated bank account",
  "Not intended",
  "Not junk",
  "Not scam",
  "Not spam",
  "Notspam",
  "Number 1",
  "Obligation",
  "Off",
  "Off everything",
  "Off shore",
  "Offer extended",
  "Offers",
  "Offshore",
  "One hundred percent",
  "One-time",
  "Online biz opportunity",
  "Online degree",
  "Online income",
  "Online job",
  "Open",
  "Opportunity",
  "Opt-in",
  "Order",
  "Order shipped by",
  "Order status",
  "Orders shipped by",
  "Orders shipped by shopper",
  "Outstanding value",
  "Outstanding values",
  "Password",
  "Passwords",
  "Pay your bills",
  "Per day/per week/per year",
  "Per month",
  "Perfect",
  "Performance",
  "Phone",
  "Please",
  "Please open",
  "Presently",
  "Print form signature",
  "Print from signature",
  "Print out and fax",
  "Priority mail",
  "Privately owned funds",
  "Prizes",
  "Problem with shipping",
  "Problem with your order",
  "Produced and sent out",
  "Profit",
  "Promise you",
  "Purchase",
  "Pure Profits",
  "Quotes",
  "Rate",
  "Real thing",
  "Rebate",
  "Reduce debt",
  "Refinance home",
  "Refinanced home",
  "Refund",
  "Regarding",
  "Removal instructions",
  "Removes",
  "Removes wrinkles",
  "Replica watches",
  "Request",
  "Request now",
  "Request today",
  "Requires initial investment",
  "Requires investment",
  "Reverses aging",
  "Risk free",
  "Rolex",
  "Round the world",
  "S 1618",
  "Safeguard notice",
  "Sale",
  "Sales",
  "Save",
  "Save $",
  " Save €",
  "Save big",
  "Save big month",
  "Save money",
  "Save now",
  "Score with babes",
  "Search engine optimisation",
  "Section 301",
  "See for yourself",
  "Seen on",
  "Serious",
  "Serious case",
  "Serious offer",
  "Serious only",
  "Sex",
  "Shop now",
  "Shopper",
  "Outstanding value",
  "Outstanding values",
  "Password",
  "Passwords",
  "Pay your bills",
  "Per day/per week/per year",
  "Per month",
  "Perfect",
  "Performance",
  "Phone",
  "Please",
  "Please open",
  "Presently",
  "Print form signature",
  "Print from signature",
  "Print out and fax",
  "Priority mail",
  "Privately owned funds",
  "Prizes",
  "Problem with shipping",
  "Problem with your order",
  "Produced and sent out",
  "Profit",
  "Promise you",
  "Purchase",
  "Pure Profits",
  "Quotes",
  "Rate",
  "Real thing",
  "Rebate",
  "Reduce debt",
  "Refinance home",
  "Refinanced home",
  "Refund",
  "Regarding",
  "Removal instructions",
  "Removes",
  "Removes wrinkles",
  "Replica watches",
  "Request",
  "Request now",
  "Request today",
  "Requires initial investment",
  "Requires investment",
  "Reverses aging",
  "Risk free",
  "Rolex",
  "Round the world",
  "S 1618",
  "Safeguard notice",
  "Sale",
  "Sales",
  "Save",
  "Save $",
  " Save €",
  "Save big",
  "Save big month",
  "Save money",
  "Save now",
  "Score with babes",
  "Search engine optimisation",
  "Section 301",
  "See for yourself",
  "Seen on",
  "Serious",
  "Serious case",
  "Serious offer",
  "Serious only",
  "Sex",
  "Shop now",
  "Shopper",
  "Shopping spree",
  "Snoring",
  "Social security number",
  "Soon",
  "Spam",
  "Spam free",
  "Special deal",
  "Special discount",
  "Special for you",
  "Special offer",
  "Stainless steel",
  "Stock alert",
  "Stock disclaimer statement",
  "Stock pick",
  "Stocks/stock pick/stock alert",
  "Stop calling me",
  "Stop emailing me",
  "Stop further distribution",
  "Stop snoring",
  "Strong buy",
  "Stuff on sale",
  "Subject to",
  "Subject to cash",
  "Subscribe",
  "Subscribe for free",
  "Subscribe now",
  "Super promo",
  "Supplies",
  "Tack action now",
  "Talks about hidden charges",
  "Talks about prizes",
  "Tells you it's an ad",
  "Terms",
  "The best rates",
  "The email asks for a credit card",
  "The following form",
  "They make a claim or claims that they're in accordance with spam law",
  "They try to keep your money no refund",
  "They're just giving it away",
  "This isn't junk",
  "This isn't spam",
  "This isn't a scam",
  "This isn't junk",
  "This isn't spam",
  "Timeshare",
  "Timeshare offers",
  "Traffic",
  "Trial unlimited",
  "U.S. dollars",
  "Undisclosed",
  "Undisclosed recipient",
  "University diplomas",
  "Unsecured credit",
  "Unsecured debt",
  "Unsolicited",
  "Unsubscribe",
  "Urgent response",
  "US dollars / Euros",
  "Vacation",
  "Vacation offers",
  "Valium",
  "Viagra",
  "Vicodin",
  "VIP",
  "Visit our website",
  "Wants credit card",
  "Warranty expired",
  "We hate spam",
  "We honor all",
  "Website visitors",
  "Weekend getaway",
  "Weight loss",
  "What's keeping you?",
  "While available",
  "While in stock",
  "While stocks last",
  "While you sleep",
  "Who really wins?",
  "Win",
  "Winner",
  "Winning",
  "Won",
  "Xanax",
  "XXX",
  "You have been chosen",
  "You have been selected",
  "Your chance",
  "Your status",
  "Zero chance",
  "Zero percent",
  "Zero risk",
  "#1",
  "%",
  "% free",
  "% Satisfied",
  "0%",
  "0% risk",
  "100%",
  "100% free",
  "100% more",
  "100% off",
  "100% satisfied",
  "99.90%",
  "99%",
  "Access for free",
  "Additional income",
  "Amazed",
  "Amazing",
  "Amazing offer",
  "Amazing stuff",
  "Be amazed",
  "Be surprised",
  "Be your own boss",
  "Believe me",
  "Best bargain",
  "Best deal",
  "Best offer",
  "Best price",
  "Best rates",
  "Big bucks",
  "Bonus",
  "Boss",
  "Can't live without",
  "Cancel",
  "Consolidate debt",
  "Double your cash",
  "Double your income",
  "Drastically reduced",
  "Earn extra cash",
  "Earn money",
  "Eliminate bad credit",
  "Expect to earn",
  "Extra",
  "Extra cash",
  "Extra income",
  "Fantastic",
  "Fantastic deal",
  "Fantastic offer",
  "FAST",
  "Fast cash",
  "Financial freedom",
  "Free access",
  "Free consultation",
  "Free gift",
  "Free hosting",
  "Free info",
  "Free investment",
  "Free membership",
  "Free money",
  "Free preview",
  "Free quote",
  "Free trial",
  "Full refund",
  "Get out of debt",
  "Giveaway",
  "Guaranteed",
  "Increase sales",
  "Increase traffic",
  "Incredible deal",
  "Join billions",
  "Join millions",
  "Join millions of Americans",
  "Join thousands",
  "Lower rates",
  "Lowest price",
  "Make money",
  "Million",
  "Million dollars",
  "Miracle",
  "Money back",
  "Month trial offer",
  "More Internet Traffic",
  "Number one",
  "Once in a lifetime",
  "One hundred percent guaranteed",
  "One time",
  "Pennies a day",
  "Potential earnings",
  "Prize",
  "Promise",
  "Pure profit",
  "Risk-free",
  "Satisfaction guaranteed",
  "Save big money",
  "Save up to",
  "Special promotion",
  "The best",
  "Thousands",
  "Unbeatable offer",
  "Unbelievable",
  "Unlimited",
  "Unlimited trial",
  "Wonderful",
  "You will not believe your eyes",
  "$$$",
  "€€€",
  "£££",
  "50% off",
  "A few bob",
  "Accept cash cards",
  "Accept credit cards",
  "Affordable",
  "Affordable deal",
  "Avoid bankruptcy",
  "Bad credit",
  "Bank",
  "Bankruptcy",
  "Bargain",
  "Billing",
  "Billing address",
  "Billion",
  "Billion dollars",
  "Billionaire",
  "Card accepted",
  "Cards accepted",
  "Cash",
  "Cash bonus",
  "Cash out",
  "Cash-out",
  "Cashcashcash",
  "Casino",
  "Cents on the dollar",
  "Check",
  "Check or money order",
  "Claim your discount",
  "Cost",
  "Costs",
  "Credit",
  "Credit bureaus",
  "Credit card",
  "Credit card offers",
  "Credit or Debit",
  "Deal",
  "Debt",
  "Discount",
  "Dollars",
  "Double your",
  "Double your wealth",
  "Earn",
  "Earn $",
  "Earn cash",
  "Earn extra income",
  "Earn from home",
  "Earn monthly",
  "Earn per month",
  "Earn per week",
  "Earn your degree",
  "Easy income",
  "Easy terms",
  "F r e e",
  "For free",
  "For just $",
  "For just $ (amount)",
  "For just $xxx",
  "Get Money",
  "Get your money",
  "Hidden assets",
  "Huge discount",
  "Income",
  "Income from home",
  "Increase revenue",
  "Increase sales/traffic",
  "Increase your chances",
  "Initial investment",
  "Instant earnings",
  "Instant income",
  "Insurance",
  "Investment",
  "Investment advice",
  "Lifetime",
  "Loans",
  "Make $",
  "",
  "Money making",
  "Money-back guarantee",
  "Money-making",
  "Monthly payment",
  "Mortgage",
  "Mortgage rates",
  "Offer",
  "One hundred percent free",
  "Only $",
  "Price",
  "Price protection",
  "Prices",
  "Profits",
  "Quote",
  "Rates",
  "Refinance",
  "Save $",
  "Serious cash",
  "Subject to credit",
  "US dollars",
  "Why pay more?",
  "Your income",
  "Acceptance",
  "Accordingly",
  "Account-based marketing (ABM)",
  "Accounts",
  "Addresses",
  "Addresses on CD",
  "Beverage",
  "Confidentiality on all orders",
  "Confidentially on all orders",
  "Content marketing",
  "Dear [email address]",
  "Dear [email/friend/somebody]",
  "Dear [first name]",
  "Dear [wrong name]",
  "Digital marketing",
  "Dormant",
  "Email extractor",
  "Email harvest",
  "Email marketing",
  "Extract email",
  "Form",
  "Freedom",
  "Friend",
  "Here",
  "Hidden",
  "Home",
  "Home based",
  "Home employment",
  "Home-based",
  "Home-based business",
  "Homebased business",
  "If you no longer wish to receive",
  "Important information regarding",
  "In accordance with laws",
  "Increase your sales",
  "Internet market",
  "Leave",
  "Lose",
  "Maintained",
  "Marketing",
  "Marketing solution",
  "Marketing solutions",
  "Medium",
  "Message contains",
  "Multi level marketing",
  "Never",
  "One time mailing",
  "Online marketing",
  "Online pharmacy",
  "Opt in",
  "Per day",
  "Per week",
  "Pre-approved",
  "Problem",
  "Removal",
  "Remove",
  "Reserves the right",
  "Reverses",
  "Sample",
  "Satisfaction",
  "Score",
  "Search engine",
  "Search engine listings",
  "Search engines",
  "Sent in compliance",
  "Solution",
  "Stop",
  "Success",
  "Teen",
  "Terms and conditions",
  "Warranty",
  "Web traffic",
  "Wife",
  "Work at home",
  "Work from home",
];

const emojis = [
  { label: "Accusatory 👎", year: 1200 },
  { label: "Angry 😡", year: 30000 },
  { label: "Appreciative 🙌", year: 1976 },
  { label: "Assertive ☝️", year: 1987 },
  { label: "Concerned 😟", year: 1765 },
  { label: "Confident 💪", year: 1098 },
  { label: "Cooperative 🤝", year: 2020 },
  { label: "Curious 🤔", year: 2021 },
  { label: "Disapproving 😖", year: 2023 },
  { label: "Egocentric 🧐", year: 2024 },
  { label: "Empathetic 😌", year: 2024 },
  { label: "Encouraging 👍", year: 2024 },
  { label: "Enthusiastic 😀", year: 2024 },
  { label: "Excited 🤩", year: 2024 },
  { label: "Friendly 😉", year: 2024 },
  { label: "Funny 😂", year: 2024 },
  { label: "Joyful 😊", year: 2024 },
  { label: "Neutral 🙂", year: 2024 },
  { label: "Optimistic ✌️", year: 2024 },
  { label: "Regretful 😥", year: 2024 },
  { label: "Sad 🙁", year: 2024 },
  { label: "Serious 😐", year: 2024 },
  { label: "Surprised 😮", year: 2024 },
  { label: "Unasumming 🙄", year: 2024 },
  { label: "Worried 😨", year: 2024 },
];

const datas = [
  { title: "Casual", year: "Default" },
  { title: "Formal", year: "Default" },
  { title: "Academic", year: "Expository" },
  { title: "Business", year: "Expository" },
  { title: "Essay", year: "Expository" },
  { title: "How-to", year: "Expository" },
  { title: "Instructions", year: "Expository" },
  { title: "Journalism", year: "Expository" },
  { title: "Legal", year: "Expository" },
  { title: "Technical", year: "Expository" },
  { title: "Anecdote", year: "Creative" },
  { title: "Biography", year: "Creative" },
  { title: "Fiction", year: "Creative" },
  { title: "Fiction", year: "Creative" },
  { title: "Poetry", year: "Creative" },
  { title: "Screenplay", year: "Creative" },
  { title: "Story", year: "Creative" },
  { title: "Advertising", year: "Persuasive" },
  { title: "Cover letter", year: "Persuasive" },
  { title: "Editorial", year: "Persuasive" },
  { title: "Marketing", year: "Persuasive" },
];
const RecipientData = [
  { title: "5-10", year: "Age range" },
  { title: "10-20", year: "Age range" },
  { title: "20-30", year: "Age range" },
  { title: "30-40", year: "Age range" },
  { title: "40-50", year: "Age range" },
  { title: "50-60", year: "Age range" },
  { title: "60-70", year: "Age range" },
  { title: "70+", year: "Age range" },
  { title: "Legal", year: "Business" },
  { title: "Accountant", year: "Business" },
  { title: "Applicant/Candidate", year: "Business" },
  { title: "Boss", year: "Business" },
  { title: "Coach", year: "Business" },
  { title: "Colleague", year: "Business" },
  { title: "Customer", year: "Business" },
  { title: "Customer Service", year: "Business" },
  { title: "Direct report", year: "Business" },
  { title: "Employee", year: "Business" },
  { title: "Journalist", year: "Business" },
  { title: "Lawyer", year: "Business" },
  { title: "Manager", year: "Business" },
  { title: "Partner", year: "Business" },
  { title: "Recruiter", year: "Business" },
  { title: "Sales lead / Prospect", year: "Business" },
  { title: "Supplier", year: "Business" },
  { title: "Tenant", year: "Business" },
  { title: "Vendor", year: "Business" },
  { title: "Banker", year: "Private" },
  { title: "Brother/Sister", year: "Private" },
  { title: "Child", year: "Private" },
  { title: "Doctor", year: "Private" },
  { title: "Friend", year: "Private" },
  { title: "Insurer", year: "Private" },
  { title: "Landlord", year: "Private" },
  { title: "Parent", year: "Private" },
  { title: "Patient", year: "Private" },
  { title: "Roommate", year: "Private" },
  { title: "Significant other", year: "Private" },
  { title: "Spouse", year: "Private" },
  { title: "Teammate", year: "Private" },
  { title: "Teenager", year: "Private" },
  { title: "Admin", year: "Education" },
  { title: "Professor", year: "Education" },
  { title: "Student", year: "Education" },
  { title: "Teacher", year: "Education" },
];
const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
var substringLength = 20;
var emailContent = "";
export class DrawerClassCampaign extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.joditRef1 = React.createRef();
    this.joditRef2 = React.createRef();
    this.state = {
      content: "",
      // pos: 0,
      open: false,
      open2: false,
      open3: false,
      open4: false,
      open6: false,
      open8: false,
      insertLink: "",
      insertLinkName:"",
      selectedVar: "",
      fallBackText: "",
      toggleDiv: false,
      selectedFolder: "",
      folderName: "",
      allUserTemplate: [],
      allTemplate: [],
      templateName: "",
      openPanels: [],
      calendlyData: [],
      subject: "",
      aMailStatus: true,
      bMailStatus: false,
      unsubscribeLink: "",
      openMuiModal: false,
      calendlyLoader: false,
      allSignatures: [],
      aiEmailForm: {
        topicTitle: "",
        tone: "",
        writingStyle: "",
        Recipient: "",
        Details: "",
      },
      emailAiHtmlContent: "",
      isFetching: false,
      showToast: false,
      activeAccordian: null,
      aiClickedType: 0,
      isOpen: false,
      isOpen2: false,
      // toneValue:'',
    };
  }

  updateContent = (value) => {
    this.props.setEmailBody(value);
    // this.setState({
    //   pos: window.getSelection().getRangeAt(0).startOffset,
    // });
  };
  updateContent2 = (value) => {
    this.props.setSubject(value);
  };
  updateContent3 = (value) => {
    this.props.setSubjectB(value);
  };

  updateContentB = (value) => {
    this.props.setEmailBodyB(value);
  };
  buttonClick = (text, val, name) => {
    if (val === 1) {
      this.jodit.selection
        .insertHTML(`&nbsp<span class="clickable-span" style='display: inline;
    padding: 2px 14px;
    width:auto;
    justify-content: center;
    align-items: center;
    gap: 10px;border-radius: 4px;
    border: 1px solid var(--color-primary, #1C485F);
    color: var(--color-primary, #1C485F);
    text-align: center;
    font-family: Source Sans 3;
    white-space: nowrap;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    cursor:pointer;
' contenteditable="false" class="clickable-span">${text}</span>&nbsp`);
    }
    else
    if (val === 3){
      this.setState({ open3: false });
      this.jodit.selection.insertHTML(
        `&nbsp<a style='color:#0000FF' href="${text}" target="_blank" rel="noopener"> ${this.state.insertLinkName} </a>&nbsp`
      );
    }  else {
      this.setState({ open3: false });
      this.jodit.selection.insertHTML(
        `&nbsp<a style='color:#0000FF' href="${text}" target="_blank" rel="noopener"> ${name} </a>&nbsp`
      );
    }
  };
  buttonClick2 = (text, val, name) => {
    console.log("ffmfmfmf", this.joditRef2.current);
    if (this.joditRef2.current) {
      this.joditRef2.current.selection
        .insertHTML(`&nbsp<span class="clickable-span" style='display: inline;
    padding: 4px 14px;
    width:auto;
    justify-content: center;
    align-items: center;
    gap: 10px;border-radius: 4px;
    border: 1px solid var(--color-primary, #1C485F);
    color: var(--color-primary, #1C485F);
    text-align: center;
    font-family: Source Sans 3;
    white-space: nowrap;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    cursor:pointer;
' contenteditable="false" class="clickable-span">${text}</span>&nbsp`);
    }
  };
  buttonClickImage = (image) => {
    this.jodit.selection.insertImage(image, null, null, null, null, null, null);
  };

  // getAllUserTemplate = () => {
  //   const userDetailsuser = JSON.parse(
  //     localStorage.getItem("MailSenderuserDetails")
  //   );
  //   axios
  //     .get(
  //       `${
  //         BaseUrl.baseurl
  //       }/email-marketing/user-template/get-user-template-details/${
  //         userDetailsuser && userDetailsuser.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${
  //             userDetailsuser && userDetailsuser.token
  //           }`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.status) {
  //         this.setState({ allUserTemplate: response.data.details.Template });
  //       } else {
  //         this.setState({ allUserTemplate: [] });
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //     })
  //     .catch((err) => console.log("Error"));
  // };
  // getAllTemplate = () => {
  //   const userDetailssss = JSON.parse(
  //     localStorage.getItem("MailSenderuserDetails")
  //   );
  //   axios
  //     .get(
  //       `${
  //         BaseUrl.baseurl
  //       }/email-marketing/user-template/get-admin-user-template/${
  //         userDetailssss && userDetailssss.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${userDetailssss && userDetailssss.token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.status) {
  //         console.log("dmdkdmdmd", response.data.details);
  //         this.setState({ allTemplate: response.data.details });
  //       } else {
  //         this.setState({ allTemplate: [] });
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //     })
  //     .catch((err) => console.log("Error"));
  // };
  // getAllSignature = () => {
  //   const userDetailssss = JSON.parse(
  //     localStorage.getItem("MailSenderuserDetails")
  //   );
  //   axios
  //     .get(
  //       `${
  //         BaseUrl.baseurl
  //       }/email-marketing/user/get-user-signature/${
  //         userDetailssss && userDetailssss.details._id
  //       }`
  //     )
  //     .then((response) => {
  //       if (response.data.status) {
  //         console.log("dmdkdmdmd", response.data.details);
  //         this.setState({ allSignatures: response.data.details.Signature });
  //       } else {
  //         this.setState({ allSignatures: [] });
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //     })
  //     .catch((err) => console.log("Error"));
  // };
  handlePanelToggle = (eventKey) => {
    // Toggle the state of the clicked panel
    const isOpen = this.state.openPanels.includes(eventKey);
    const newOpenPanels = isOpen
      ? this.state.openPanels.filter((key) => key !== eventKey)
      : [...this.state.openPanels, eventKey];

    this.setState({ openPanels: newOpenPanels });
  };

  componentDidMount() {
    // this.setEndOfContentEditable();
    window.addEventListener("click", this.handleOutsideClick);
    window.addEventListener("click", this.handleOutsideClick2);
    window.addEventListener("click", this.handleOutsideClick3);
    window.addEventListener("click", this.handleOutsideClick4);
    // Add event listener for click events on spans within the editor
    document.addEventListener("click", this.handleSpanClick);
    // this.getAllUserTemplate();
    // this.getAllTemplate();
    // this.getAllSignature();
    // this.setState({selectedFolder:this.props.selectedFolder})
    // if(this.props.editableDataObj!==null){
    //   this.setState({templateName:this.props.editableDataObj.SubName})
    //   this.setState({content:this.props.editableDataObj.SubTemplate})
    //   this.setState({subject:this.props.editableDataObj.SubSubject})
    // }
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.subject !== prevProps.subject) {
  //     this.setEndOfContentEditable();
  //   }
  // }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
    document.removeEventListener("click", this.handleSpanClick);
    window.removeEventListener("click", this.handleOutsideClick);
    window.removeEventListener("click", this.handleOutsideClick2);
    window.removeEventListener("click", this.handleOutsideClick3);
    window.removeEventListener("click", this.handleOutsideClick4);
  }
  handleSpanClick = (event) => {
    const clickedElement = event.target;

    // Check if the clicked element is a span with the specified class
    if (clickedElement.classList.contains("clickable-span")) {
      // alert(`Clicked on "${clickedElement.innerText}"`);
      this.setState({ open: true });
      this.setState({ selectedVar: clickedElement.innerText });
      // Add your custom logic here for handling the click event
    }
  };
  createFolderNameTemplate = () => {
    let userData = {
      templateName: this.state.folderName,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/user-template/create-template/${
          userDetails && userDetails.details._id
        }`,
        userData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.getAllUserTemplate();
          this.setState({ folderName: "" });
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };
  test = () => {
    return (
      <div style={{ position: "relative" }}>
        {console.log("jabba", this.state.allUserTemplate)}
        <div
          onClick={() => this.setState({ toggleDiv: !this.state.toggleDiv })}
          style={{
            border: "1px solid #DDD",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px",
            cursor: "pointer",
          }}
        >
          <p>
            {" "}
            {this.state.selectedFolder
              ? this.state.selectedFolder.Name
              : "selected folder here"}{" "}
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M16.6004 7.45825L11.1671 12.8916C10.5254 13.5333 9.47539 13.5333 8.83372 12.8916L3.40039 7.45825"
              stroke="#393939"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        {this.state.toggleDiv && (
          <div
            style={{
              border: "1px solid #DDD",
              borderRadius: "6px",
              position: "absolute",
              bottom: 0,
              top: 40,
              zIndex: 10000,
              width: "-webkit-fill-available",
              backgroundColor: "#fff",
              height: "max-content",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
                borderBottom: "1px solid #DDD",
                padding: "4px",
              }}
            >
              <input
                value={this.state.folderName}
                onChange={(e) => {
                  this.setState({ folderName: e.target.value });
                }}
                type="text"
                style={{
                  flexGrow: 1,
                  padding: "10px",
                  outline: "none",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                }}
                placeholder="Create floder name"
              />
              <button
                onClick={() => {
                  this.createFolderNameTemplate();
                }}
                style={{
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  padding: "10px 18px",
                  color: "#000",
                  outline: "none",
                  border: "1px solid #DDD",
                }}
              >
                Create
              </button>
            </div>
            <ul style={{ padding: "12px" }}>
              {this.state.allUserTemplate.length !== 0 &&
                this.state.allUserTemplate.map((val) => {
                  return (
                    <li
                      onClick={() => {
                        this.setState({ toggleDiv: !this.state.toggleDiv });
                        this.setState({ selectedFolder: val });
                      }}
                      key={val._id}
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #DDD",
                        cursor: "pointer",
                      }}
                    >
                      {val.Name}
                    </li>
                  );
                })}
            </ul>
          </div>
        )}
      </div>
    );
  };
  getAllCalendlyData = (token, organization, reftoken, owner) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://api.calendly.com/event_types?active=true&organization=${organization}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        this.setState({ calendlyLoader: false });
        this.setState({ open3: true });

        this.setState({
          calendlyData: response.data,
        });
        let data = JSON.stringify({
          url: "https://mail.goone.club/email-marketing/automation/trigger-calendly-email-lead-main",
          events: [
            "invitee.created",
            "invitee.canceled",
            "invitee_no_show.created",
          ],
          organization: organization,
          user: owner,
          scope: "organization",
          // "signing_key": "YYJYULqMncq9ksIwtFDvs_EZ7tBnK_8x8sF-caz81TU"
        });
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://api.calendly.com/webhook_subscriptions",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            this.setState({ showToast: true });
            toast.success("web hook connected successfully", {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          })
          .catch((error) => {
            this.setState({ showToast: true });
            toast.error(
              "Please upgrade your calendly account to standard plan or higher",
              {
                autoClose: true,
                position: "top-right",
                duration: 3000,
              }
            );
          });
      })
      .catch((error) => {
        this.createAccessToken(reftoken, organization, owner);
      });
  };
  createAccessToken = (refToken, organization, owner) => {
    axios
      .post(
        `https://calendly.com/oauth/token?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&client_secret=QP2iUiADJkDBQzFudVSdKU_llhekpna7sNZ73lLgqRQ&refresh_token=${refToken}&grant_type=refresh_token`
      )
      .then((result) => {
        if (result.data) {
          let accData = {
            calendlyAccessToken: result.data.access_token,
          };
          axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/user/update-user-calendly-access-token/${
                userDetails && userDetails.details._id
              }`,
              accData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                this.getAllCalendlyData(
                  result.data.access_token,
                  organization,
                  refToken,
                  owner
                );
              } else {
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        }
      })
      .catch((err) => {
        window.location.href =
          "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
      });
  };
  connectCalendly = () => {
    const userDetailsFrom = JSON.parse(
      localStorage.getItem("MailSenderuserDetails")
    );
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetailsFrom && userDetailsFrom.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${
              userDetailsFrom && userDetailsFrom.token
            }`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.details.CalendlyAddedStatus) {
            this.getAllCalendlyData(
              response.data.details.CalendlyAccessToken,
              response.data.details.CalendlyOrganization,
              response.data.details.CalendlyRefreshToken,
              response.data.details.CalendlyOwner
            );
          } else {
            this.props.setLocalStorageData();
            window.location.href =
              "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
          }
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };
  createTemplatetoFolder = () => {
    let tmpData = {
      subName: this.state.templateName,
      subTemplate: this.props.emailBody,
      subSubject: this.props.subject,
    };
    axios
      .put(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-template/add-template-details/${
          userDetails && userDetails.details._id
        }/${this.state.selectedFolder._id}`,
        tmpData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.setState({ templateName: "" });
          this.setState({ content: "" });
          this.setState({ open2: false });

          this.getAllTemplate();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        this.setState({ showToast: true });
        if (response.data.status) {
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        }
      })
      .catch((err) => console.log("Error"));
  };

  config = {
    readonly: false,
    events: {
      afterInit: (instance) => {
        this.jodit = instance;
      },
    },
    buttons:
      "undo,redo,font,fontsize,bold,italic,underline,ol,ul,center,justify,left,right",
    toolbarAdaptive: false,
    showCharsCounter: false,
    showXPathInStatusbar: false,
    statusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_only_text",
    cleanHTML: true,
  };
  config2 = {
    readonly: false,
    events: {
      afterInit: (instance) => {
        this.jodit = instance;
      },
    },
    buttons:
      "undo,redo,font,fontsize,bold,italic,underline,ol,ul,center,justify,left,right",
    toolbarAdaptive: false,
    showCharsCounter: false,
    showXPathInStatusbar: false,
    statusbar: false,
    toolbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_only_text",
    cleanHTML: true,
    enter: "br",
    height: 10,
    minHeight: 20,
    maxHeight: 200,
    allowResizeX: false,
    allowResizeY: false,
  };

  processEmailContent = () => {
    // Extract the next 10 characters
    const nextCharacters = emailContent.substring(0, substringLength);
    if (this.state.aiClickedType === 1) {
      this.props.setEmailBody(nextCharacters);
    } else if (this.state.aiClickedType === 2) {
      this.props.setEmailBody(nextCharacters);
    } else if (this.state.aiClickedType === 3) {
      this.props.setEmailBodyB(nextCharacters);
    }

    this.setState({
      pos: window.getSelection().getRangeAt(0).startOffset,
    });
    // Increment the substring length for the next iteration
    substringLength += 10;
    // Check if we have reached the end of the string
    if (substringLength <= emailContent.length) {
      // Schedule the next iteration after the specified delay
      setTimeout(() => this.processEmailContent(), 200);
    } else {
      console.log("Reached the end of the string. Stopping further calls.");
    }
  };
  highlightSpamWords = (htmlString) => {
    vikki3.forEach((word) => {
      // const regex = new RegExp(`\\b${word}\\b`, 'gi');
      htmlString = htmlString.replace(
        word,
        `<span style="text-decoration: underline; color: red;">${word}</span>`
      );
    });

    return htmlString;
  };
  handleAiEmailFormSubmit = (e) => {
    e.preventDefault();
    if (this.state.aiEmailForm.Recipient === "") {
      this.setState({ showToast: true });
      toast.error("Recipient filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }

    if (this.state.aiEmailForm.tone === "") {
      this.setState({ showToast: true });
      toast.error("Tone filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }
    if (this.state.aiEmailForm.writingStyle === "") {
      this.setState({ showToast: true });
      toast.error("Writing style filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }
    // console.log("eamil data", this.state.aiEmailForm)
    let dynamicContent = `Generate a email content should be in html tag and should not contain subject and buttons and images format containing topic to ${
      this.state.aiEmailForm.topicTitle
    }, should be in black for ${
      this.state.aiEmailForm.Recipient.title.includes("-" || "+")
        ? `Age range between ${this.state.aiEmailForm.Recipient.title} recipients`
        : this.state.aiEmailForm.Recipient.title
    }, tone is like ${
      this.state.aiEmailForm.tone.label
    }, writing style shoud be ${
      this.state.aiEmailForm.writingStyle.title
    } and ${this.state.aiEmailForm.Details} body in html`;
    this.setState({ isFetching: true });
    const api = `${BaseUrl.baseurl}/email-marketing/open-ai/generate-email-content`;
    axios
      .post(
        api,
        { content: dynamicContent },
        {
          headers: {
            Authorization: `Bearer ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // console.log("getting the reponse==========>", response.data.details);
          this.setState({ emailAiHtmlContent: response.data.details });
          // this.setState({content:response.data.details})
          this.setState({ openMuiModal: false });
          this.setState({ isFetching: false });
          if (this.state.aiClickedType === 1) {
            this.props.setEmailBody(response.data.details);
          } else if (this.state.aiClickedType === 2) {
            this.props.setEmailBody(response.data.details);
          } else if (this.state.aiClickedType === 3) {
            this.props.setEmailBodyB(response.data.details);
          }
          this.setState({
            pos: window.getSelection().getRangeAt(0).startOffset,
          });
          // emailContent = response.data.details;
          // this.processEmailContent();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleAiEmailFormOnchange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: value,
      },
    }));
  };

  handleAutocompleteChange = (name, newValue) => {
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: newValue,
      },
    }));
    // console.log(`Selected ${name}:`, newValue);
  };

  muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={this.state.openMuiModal}
        onClose={() => this.setState({ openMuiModal: false })}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={this.state.openMuiModal}>
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "12px",
              }}
            >
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                sx={{
                  fontSize: "26px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                AI Email Writer
              </Typography>
              <Button
                disableRipple
                disableElevation
                sx={{
                  display: "flex",
                  outline: "none !important",
                  justifyContent: "flex-end",
                  padding: "0px",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
                onClick={() => this.setState({ openMuiModal: false })}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>
            <form
              onSubmit={this.handleAiEmailFormSubmit}
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label
                  htmlFor="email-content"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Email topic (200 chars max)
                </label>
                <input
                  value={this.state.aiEmailForm.topicTitle}
                  name="topicTitle"
                  onChange={this.handleAiEmailFormOnchange}
                  id="email-content"
                  type="text"
                  style={{
                    backgroundColor: "transparent",
                    padding: "8px 12px",
                    border: "1px solid #DDD",
                    borderRadius: "4px",
                    outline: "none",
                    border: "1px solid #1C485F",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="Tone"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Tone
                </label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={emojis}
                  size="small"
                  sx={{ width: "100%" }}
                  value={this.state.aiEmailForm.tone || null}
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("tone", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="writing-style"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Writing style
                </label>
                <Autocomplete
                  id="grouped-demo"
                  value={this.state.aiEmailForm.writingStyle || null}
                  size="small"
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("writingStyle", newValue)
                  }
                  options={datas.sort((a, b) =>
                    b.year.toString().localeCompare(a.year.toString())
                  )}
                  groupBy={(option) => option.year}
                  getOptionLabel={(option) => option.title}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      variant="outlined"
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="writing-style"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Recipient
                </label>
                <Autocomplete
                  id="grouped-demo"
                  value={this.state.aiEmailForm.Recipient || null}
                  size="small"
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("Recipient", newValue)
                  }
                  options={RecipientData.sort((a, b) =>
                    b.year.toString().localeCompare(a.year.toString())
                  )}
                  groupBy={(option) => option.year}
                  getOptionLabel={(option) => option.title}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      variant="outlined"
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="Details"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Details (optional - 600 chars max)
                </label>
                <input
                  type="text"
                  id="Details"
                  value={this.state.aiEmailForm.Details}
                  name="Details"
                  onChange={this.handleAiEmailFormOnchange}
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "transparent",
                    borderRadius: "4px",
                    outline: "none",
                    border: "1px solid #DDD",
                    border: "1px solid #1C485F",
                  }}
                  placeholder="Enter additional details you want to include"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "12px",
                  gap: "13px",
                }}
              >
                <button
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                  onClick={() => this.setState({ openMuiModal: false })}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    textTransform: "none",
                    background: "#1C485F",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {this.state.isFetching && (
                    <CircularProgress
                      size={15}
                      style={{
                        color: "#FFF",
                      }}
                    />
                  )}
                  Add
                </button>
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  };
  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };
  toggleDropdown3 = () => {
    if (this.state.allSignatures.length === 0) {
      toast.error("No signature present ! please create signature");
    }

    this.setState((prevState) => ({
      isOpen3: !prevState.isOpen3,
    }));
  };
  toggleDropdown4 = () => {
    if (this.state.allSignatures.length === 0) {
      toast.error("No signature present ! please create signature");
    }

    this.setState((prevState) => ({
      isOpen4: !prevState.isOpen4,
    }));
  };
  toggleDropdown2 = () => {
    this.setState((prevState) => ({
      isOpen2: !prevState.isOpen2,
    }));
  };

  closeDropdown = () => {
    this.setState({
      isOpen: false,
    });
  };

  closeDropdown2 = () => {
    this.setState({
      isOpen2: false,
    });
  };
  closeDropdown3 = () => {
    this.setState({
      isOpen3: false,
    });
  };
  closeDropdown4 = () => {
    this.setState({
      isOpen4: false,
    });
  };
  handleOutsideClick = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.closeDropdown();
    }
  };
  handleOutsideClick2 = (event) => {
    if (this.dropdownRef2 && !this.dropdownRef2.contains(event.target)) {
      this.closeDropdown2();
    }
  };
  handleOutsideClick3 = (event) => {
    if (this.dropdownRef3 && !this.dropdownRef3.contains(event.target)) {
      this.closeDropdown3();
    }
  };
  handleOutsideClick4 = (event) => {
    if (this.dropdownRef4 && !this.dropdownRef4.contains(event.target)) {
      this.closeDropdown4();
    }
  };
  handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64Result = e.target.result;
        // Now you can use the base64Result as needed
        this.buttonClickImage(base64Result);
        // You may want to set the base64 result to the state or perform other actions.
      };

      // Read the file as base64
      reader.readAsDataURL(file);
    }
  };
  triggerFileInput = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*"; // Allow only image files
    fileInput.style.display = "none";

    // Attach an event listener to the file input to handle the file selection
    fileInput.addEventListener("change", this.handleFileUpload);

    // Trigger a click event on the file input to open the file selection dialog
    fileInput.click();
  };
  editorDataClick = (id, from) => {
    if (id === 4) {
      this.setState({ openMuiModal: true });
      this.setState({ open3: false });
      this.setState({ open4: false });
      this.setState({ open8: false });
      this.setState({ aiClickedType: from });
    } else if (id === 6) {
      this.setState({ calendlyLoader: true });
      this.connectCalendly();
      this.setState({ openMuiModal: false });
      this.setState({ open4: false });
      this.setState({ open8: false });
    } else if (id === 5) {
      this.setState({ open4: true });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open8: false });
    } else if (id === 8) {
      this.setState({ open8: true });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open4: false });
    } else if (id === 7) {
      this.triggerFileInput();
      this.setState({ open8: false });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open4: false });
    } else if (id === 9) {
      this.setState({ open8: false });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open4: false });

      if (this.props.abTestingStatus) {
        if (this.aMailStatus) {
          if (this.props.emailBody !== "") {
            this.props.setEmailBody(
              this.highlightSpamWords(this.props.emailBody)
            );
            toast.success(
              "Red Underlined words all are spam please change for better inbox delivery!!",
              {
                autoClose: true,
                position: "top-right",
                duration: 3000,
              }
            );
          } else {
            toast.error("Please add email body", {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          }
        } else {
          if (this.props.emailBodyB !== "") {
            this.props.setEmailBodyB(
              this.highlightSpamWords(this.props.emailBodyB)
            );

            toast.success(
              "Red Underlined words all are spam please change for better inbox delivery!!",
              {
                autoClose: true,
                position: "top-right",
                duration: 3000,
              }
            );
          } else {
            toast.error("Please add email body", {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          }
        }
      } else {
        if (this.props.emailBody !== "") {
          this.props.setEmailBody(
            this.highlightSpamWords(this.props.emailBody)
          );
          toast.success(
            "Red Underlined words all are spam please change for better inbox delivery!!",
            {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            }
          );
        } else {
          toast.error("Please add email body", {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        }
      }
    }
  };
  handleEmojiSelect = (emoji) => {
    this.props.setSubject((prevText) => prevText + emoji.native);
  };
  // getCaretPosition = () => {
  //   const selection = window.getSelection();
  //   return selection.focusOffset;
  // };
  // setEndOfContentEditable = () => {
  //   const range = document.createRange();
  //   range.selectNodeContents(this.inputRef.current);
  //   range.collapse(false); // Collapse the range to the end
  //   const selection = window.getSelection();
  //   selection.removeAllRanges();
  //   selection.addRange(range);
  // };

  // handleKeyDown = (e) => {
  //   if (e.key === 'Backspace' && this.getCaretPosition() === 0) {
  //     // Prevent navigating to the beginning of the content
  //     e.preventDefault();
  //   }
  // };

  setRef = (jodit, ref) => {
    // Set the Jodit instance to the specified ref
    this[ref].current = jodit;
  };
  render() {
    const { isOpen, isOpen2, isOpen3, isOpen4 } = this.state;

    return (
      <div
        style={{
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              padding: "12px 16px",
              borderBottom: "1px solid #DDD",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {!this.props.abTestingStatus && (
              <p
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "22px",
                  fontWeight: 700,
                  fontStyle: "normal",
                }}
              >
                Email
              </p>
            )}

            {this.props.abTestingStatus && (
              <>
                <FormControlLabel
                  sx={{ marginRight: "0px", marginLeft: "0px" }}
                  value="all"
                  control={
                    <Radio style={{ color: "#1C485F", padding: "2px" }} />
                  }
                  label="A Mail"
                  onClick={() => {
                    this.setState({ aMailStatus: true });
                    this.setState({ bMailStatus: false });
                  }}
                  checked={this.state.aMailStatus}
                />
                <FormControlLabel
                  sx={{ marginRight: "0px" }}
                  value="all"
                  control={
                    <Radio style={{ color: "#1C485F", padding: "2px" }} />
                  }
                  label="B Mail"
                  onClick={() => {
                    this.setState({ aMailStatus: false });
                    this.setState({ bMailStatus: true });
                  }}
                  checked={this.state.bMailStatus}
                />
              </>
            )}
            <FormControlLabel
              onClick={() => {
                this.setState({ aMailStatus: true });
                this.setState({ bMailStatus: false });
                this.props.setABTestingStatus(!this.props.abTestingStatus);
              }}
              sx={{ marginRight: "0px" }}
              control={
                <Switch
                  checked={this.props.abTestingStatus}
                  style={{ color: "#1c485f", marginRight: "0px" }}
                />
              }
              label="A/B Testing"
            />
          </div>
          {!this.props.abTestingStatus ? (
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                border: "1px solid #DDD",
                borderRadius: 5,
                margin: 16,
                padding: "12px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "relative",
                  alignItems: "center",
                  borderBottom: "1px solid #DDD",
                  paddingBottom: "10px",
                  display: "flex",
                  // gap: "14px",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    width: "92%",
                  }}
                >
                  <p
                    style={{
                      color: "#393939",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 700,
                      marginBottom: 0,
                      fontStyle: "normal",
                    }}
                  >
                    Subject:
                  </p>
                  <div style={{ width: "94%" }}>
                    <JoditEditor
                      ref={(jodit) => this.setRef(jodit, "joditRef2")}
                      value={this.props.subject}
                      config={this.config2}
                      tabIndex={1} // tabIndex of textarea
                      onBlur={this.updateContent2}
                      placeholder="Write something attention-grabbing"
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  ref={(ref) => (this.dropdownRef2 = ref)}
                >
                  <button
                    className="variableaddingbox2"
                    style={{
                      marginTop: "0px",
                      padding: "10px 20px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                    }}
                    onClick={this.toggleDropdown2}
                  >
                    <Tooltip title="Variables will be inserted" arrow>
                      <span>
                        <VariablLightSvg />
                      </span>
                    </Tooltip>
                  </button>

                  {isOpen2 && (
                    <div
                      className="dropdown-content"
                      style={{
                        right: "0px",
                      }}
                    >
                      {this.props.variableArray.map((val) => {
                        return (
                          <p
                            className="variablerowbox"
                            onClick={() => {
                              this.closeDropdown2();
                              this.buttonClick2(val, 1, "vig");
                            }}
                          >
                            {val}
                          </p>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  position: "relative",
                  flexGrow: 1,
                  // margin: "0px 10px",
                  backgroundColor: "#FFF",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    backgroundColor: "#FFF",
                    borderRadius: "4px",
                    width: "100%",
                    padding: "10px 0px",
                  }}
                >
                  <div style={{ display: "flex", gap: "14px" }}>
                    <div ref={(ref) => (this.dropdownRef = ref)}>
                      <button
                        className="variableaddingbox"
                        style={{
                          marginTop: "0px",
                          borderRadius: 5,
                          padding: "11px 20px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                        }}
                        onClick={this.toggleDropdown}
                      >
                        <Tooltip title="Variables will be inserted" arrow>
                          <span>
                            <VariablLightSvg />
                          </span>
                        </Tooltip>
                      </button>
                      {isOpen && (
                        <div className="dropdown-content">
                          {this.props.variableArray.map((val) => {
                            return (
                              <p
                                className="variablerowbox"
                                onClick={() => {
                                  this.closeDropdown();
                                  this.buttonClick(val, 1, "vig");
                                }}
                              >
                                {val}
                              </p>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      flexGrow: 1,
                      // padding: "10px 0px",
                      // paddingTop: "6px",
                    }}
                  >
                    {editorData.map((editor, idx) => (
                      <button
                        onClick={() => {
                          this.editorDataClick(editor.id, 1);
                        }}
                        key={editor.id}
                        className="emailvariablesbox"
                        style={{
                          padding: "10px 20px",
                        }}
                      >
                        {this.state.calendlyLoader && editor.id === 6 ? (
                          <div
                            style={{
                              paddingLeft: "24x",
                              paddingRight: "24px",
                              textAlign: "center",
                            }}
                          >
                            <CircularProgress
                              size={14}
                              style={{
                                color: "#1c485f",
                                marginLeft: "32px",
                              }}
                            />
                          </div>
                        ) : (
                          editor.text
                        )}
                      </button>
                    ))}
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    // position: "absolute",
                    // top: 40,
                    height: "-webkit-fill-available",
                  }}
                >
                  <JoditEditor
                    ref={(jodit) => this.setRef(jodit, "joditRef1")}
                    value={this.props.emailBody}
                    config={this.config}
                    tabIndex={1} // tabIndex of textarea
                    onBlur={this.updateContent}
                    // onChange={this.updateContent}
                  />
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#FFF",
                  width: "100%",
                  paddingTop: "14px",
                  // borderTop: "1px solid #DDD",
                  zIndex: 200,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    // justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => {
                      this.props.createEmailForNode();
                      this.props.setOpen3(false);
                    }}
                    style={{
                      padding: "7px 24px",
                      borderRadius: "4px",
                      color: "#fff",
                      outline: "none",
                      backgroundColor: "#FF3301",
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              {this.state.aMailStatus ? (
                <div
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    border: "1px solid #DDD",
                    borderRadius: 5,
                    margin: 16,
                    padding: "12px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      // display: "flex",
                      position: "relative",
                      alignItems: "center",
                      gap: "2px",
                      borderBottom: "1px solid #DDD",
                      // borderRadius: "6px",
                      // margin: "0px 10px",
                      paddingBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      // height: "40px",
                    }}
                  >
                    <div
                      style={{
                        // position: "absolute",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        width: "92%",
                      }}
                    >
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 700,
                          marginBottom: 0,
                          fontStyle: "normal",
                        }}
                      >
                        SubjectA:
                      </p>
                      <div style={{ width: "94%" }}>
                        <JoditEditor
                          ref={(jodit) => this.setRef(jodit, "joditRef2")}
                          value={this.props.subject}
                          config={this.config2}
                          tabIndex={1} // tabIndex of textarea
                          onBlur={this.updateContent2}
                          placeholder="Write something attention-grabbing"
                        />
                      </div>
                    </div>

                    {/* <div
                      style={{
                        height: "100%",
                        overflowY: "scroll",
                        position: "absolute",
                        left: 80,
                        width: "75%",
                      }}
                    >
                      <JoditEditor
                        ref={(jodit) => this.setRef(jodit, "joditRef2")}
                        value={this.props.subject}
                        config={this.config2}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={this.updateContent2}
                        placeholder="Write something attention-grabbing"
                      />
                    </div> */}
                    <div
                      style={{
                        // width: "15%",
                        // position: "absolute",
                        // right: 0,
                        // height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      ref={(ref) => (this.dropdownRef2 = ref)}
                    >
                      <button
                        className="variableaddingbox2"
                        style={{
                          marginTop: "0px",
                          padding: "10px 20px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                        }}
                        onClick={this.toggleDropdown2}
                      >
                        <Tooltip title="Variables will be inserted" arrow>
                          <span>
                            <VariablLightSvg />
                          </span>
                        </Tooltip>
                      </button>
                      {isOpen2 && (
                        <div
                          className="dropdown-content"
                          style={{
                            right: "0px",
                          }}
                        >
                          {this.props.variableArray.map((val) => {
                            return (
                              <p
                                className="variablerowbox"
                                onClick={() => {
                                  this.closeDropdown2();
                                  this.buttonClick2(val, 1, "vig");
                                }}
                              >
                                {val}
                              </p>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      position: "relative",
                      flexGrow: 1,
                      backgroundColor: "#FFF",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "flex-start",
                        backgroundColor: "#FFF",
                        borderRadius: "4px",
                        width: "100%",
                        padding: "10px 0px",
                      }}
                    >
                      <div style={{ display: "flex", gap: "14px" }}>
                        <div ref={(ref) => (this.dropdownRef = ref)}>
                          <button
                            className="variableaddingbox"
                            style={{
                              marginTop: "0px",
                              borderRadius: 5,
                              padding: "11px 20px",
                              boxShadow:
                                "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                            }}
                            onClick={this.toggleDropdown}
                          >
                            <Tooltip title="Variables will be inserted" arrow>
                              <span>
                                <VariablLightSvg />
                              </span>
                            </Tooltip>
                          </button>
                          {isOpen && (
                            <div className="dropdown-content">
                              {this.props.variableArray.map((val) => {
                                return (
                                  <p
                                    className="variablerowbox"
                                    onClick={() => {
                                      this.closeDropdown();
                                      this.buttonClick(val, 1, "vig");
                                    }}
                                  >
                                    {val}
                                  </p>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexGrow: 1,
                          // paddingTop: "6px",
                        }}
                      >
                        {editorData.map((editor, idx) => (
                          <button
                            onClick={() => {
                              this.editorDataClick(editor.id, 2);
                            }}
                            key={editor.id}
                            className="emailvariablesbox"
                            style={{
                              padding: "10px 20px",
                            }}
                          >
                            {editor.text}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        // position: "absolute",
                        // top: 40,
                        height: "-webkit-fill-available",
                      }}
                    >
                      <JoditEditor
                        ref={(jodit) => this.setRef(jodit, "joditRef1")}
                        value={this.props.emailBody}
                        config={this.config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={this.updateContent}
                        // onChange={this.updateContentA}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#FFF",
                      width: "100%",
                      paddingTop: "14px",
                      zIndex: 200,
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                        // justifyContent: "center",
                      }}
                    >
                      <button
                        onClick={() => {
                          this.props.createEmailForNode();
                          this.props.setOpen3(false);
                        }}
                        style={{
                          padding: "7px 24px",
                          borderRadius: "4px",
                          color: "#fff",
                          outline: "none",
                          backgroundColor: "#FF3301",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    border: "1px solid #DDD",
                    borderRadius: 5,
                    margin: 16,
                    padding: "12px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      alignItems: "center",
                      borderBottom: "1px solid #DDD",
                      paddingBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                    }}
                  >
                    <div
                      style={{
                        // position: "absolute",
                        height: "100%",
                        display: "flex",
                        // justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                        width: "92%",
                      }}
                    >
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 700,
                          marginBottom: 0,
                          fontStyle: "normal",
                        }}
                      >
                        SubjectB:
                      </p>
                      <div style={{ width: "94%" }}>
                        <JoditEditor
                          ref={(jodit) => this.setRef(jodit, "joditRef2")}
                          value={this.props.subjectB}
                          config={this.config2}
                          tabIndex={1} // tabIndex of textarea
                          onBlur={this.updateContent3}
                          placeholder="Write something attention-grabbing"
                        />
                      </div>
                    </div>

                    {/* <div
                      style={{
                        height: "100%",
                        overflowY: "scroll",
                        position: "absolute",
                        left: 80,
                        width: "75%",
                      }}
                    >
                      <JoditEditor
                        ref={(jodit) => this.setRef(jodit, "joditRef2")}
                        value={this.props.subjectB}
                        config={this.config2}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={this.updateContent3}
                        placeholder="Write something attention-grabbing"
                      />
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      ref={(ref) => (this.dropdownRef2 = ref)}
                    >
                      <button
                        className="variableaddingbox2"
                        style={{
                          marginTop: "0px",
                          padding: "10px 20px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                        }}
                        onClick={this.toggleDropdown2}
                      >
                        <Tooltip title="Variables will be inserted" arrow>
                          <span>
                            <VariablLightSvg />
                          </span>
                        </Tooltip>
                      </button>
                      {isOpen2 && (
                        <div
                          className="dropdown-content"
                          style={{
                            right: "0px",
                          }}
                        >
                          {this.props.variableArray.map((val) => {
                            return (
                              <p
                                className="variablerowbox"
                                onClick={() => {
                                  this.closeDropdown2();
                                  this.buttonClick2(val, 1, "vig");
                                }}
                              >
                                {val}
                              </p>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      position: "relative",
                      flexGrow: 1,
                      // margin: "0px 10px",
                      backgroundColor: "#FFF",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "flex-start",
                        backgroundColor: "#FFF",
                        borderRadius: "4px",
                        width: "100%",
                        padding: "10px 0px",
                      }}
                    >
                      <div style={{ display: "flex", gap: "14px" }}>
                        <div ref={(ref) => (this.dropdownRef = ref)}>
                          <button
                            className="variableaddingbox"
                            style={{
                              marginTop: "0px",
                              borderRadius: 5,
                              padding: "11px 20px",
                              boxShadow:
                                "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                            }}
                            onClick={this.toggleDropdown}
                          >
                            <Tooltip title="Variables will be inserted" arrow>
                              <span>
                                <VariablLightSvg />
                              </span>
                            </Tooltip>
                          </button>
                          {isOpen && (
                            <div className="dropdown-content">
                              {this.props.variableArray.map((val) => {
                                return (
                                  <p
                                    className="variablerowbox"
                                    onClick={() => {
                                      this.closeDropdown();
                                      this.buttonClick(val, 1, "vig");
                                    }}
                                  >
                                    {val}
                                  </p>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexGrow: 1,
                        }}
                      >
                        {editorData.map((editor, idx) => (
                          <button
                            onClick={() => {
                              this.editorDataClick(editor.id, 3);
                            }}
                            key={editor.id}
                            className="emailvariablesbox"
                            style={{
                              padding: "10px 20px",
                            }}
                          >
                            {editor.text}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        // position: "absolute",
                        // top: 40,
                        height: "-webkit-fill-available",
                      }}
                    >
                      <JoditEditor
                        ref={(jodit) => this.setRef(jodit, "joditRef1")}
                        value={this.props.emailBodyB}
                        config={this.config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={this.updateContentB}
                        // onChange={this.updateContentB}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#FFF",
                      width: "100%",
                      paddingTop: "14px",
                      zIndex: 200,
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                      }}
                    >
                      <button
                        onClick={() => {
                          this.props.createEmailForNode();
                          this.props.setOpen3(false);
                        }}
                        style={{
                          padding: "7px 24px",
                          borderRadius: "4px",
                          color: "#fff",
                          outline: "none",
                          backgroundColor: "#FF3301",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {this.state.open3 && (
            <div
              className="modalPopupDelete"
              style={{
                top: "25%",
                left: "29%",
                width: "40vw",
                borderRadius: "10px",
                background: "var(--color-white, #FFF)",
                boxShadow: "0px 2px 10px 0px rgba(25, 1, 52, 0.12)",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                padding: "0px",
                paddingBottom: "10px",
                zIndex: 200000,
              }}
            >
              <div className="calendlymeethead">
                Available Calendly meeting{" "}
                <ClearIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    this.setState({ open3: false });
                  }}
                />
              </div>

              <div className="listcalendlybos">
                {this.state.calendlyData.collection.length === 0 && (
                  <div className="subheadcalendl">
                    No Calendly Link present. Please create calendly schedule in
                    calendly site.
                  </div>
                )}

                {this.state.calendlyData.length !== 0 &&
                  this.state.calendlyData.collection.map((val) => {
                    let dmUrl = val.scheduling_url;
                    return (
                      <>
                        {val.active && (
                          <div className="calendlyboxalign">
                            <div className="insideboixcalend">
                              <div className="calendtexthead">{val.name}</div>
                              <div className="subheadcalendl">
                                {val.duration}mins /
                                {dmUrl.replace("https://calendly.com/", "")}
                              </div>
                            </div>
                            <div
                              className="inserlinkcALEND"
                              onClick={() => {
                                this.buttonClick(
                                  `${val.scheduling_url}?utm_source=userId&utm_content=node&utm_campaign=campaignId`,
                                  2,
                                  val.name
                                );
                              }}
                            >
                              Insert link
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
        <style>
          {`
                .rs-drawer-header .rs-drawer-header-close{
                    display: none;
                }
            `}
        </style>
        {this.state.openMuiModal && this.muiModal()}
        {this.state.open4 && (
          <div
            className="modalPopupDelete"
            style={{
              top: "35%",
              width: "40vw",
              left: "9%",
              borderRadius: "10px",
              background: "var(--color-white, #FFF)",
              boxShadow: "4px 4px 10px 4px #DDD",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              padding: "20px",
              paddingBottom: "10px",
              zIndex: 200000,
            }}
          >
            <div className="modaltext">Unsubscribe Link</div>
            <div className="modalsubtext">
              Enter the link text. This is the text that will offer your
              recipients to unsubscribe, for example: Click here to unsubscribe.
              Coldsender.com will generate and add your custom unsubscribe link to it.
            </div>
            <TextField
              autoComplete="off"
              value={this.state.unsubscribeLink}
              onChange={(e) => {
                this.setState({ unsubscribeLink: e.target.value });
              }}
              variant="standard"
              placeholder="For example: Click here to unsubscribe"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: "37vw",
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  this.setState({ open4: false });
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                style={{
                  // opacity: this.state.unsubscribeLink === "" && 0.4,
                  pointerEvents: this.state.unsubscribeLink === "" && "none",
                }}
                onClick={() => {
                  this.buttonClick(
                    "https://app.coldsender.com/UnSubscribe/unsubscribemail/unsubscribecampaignid",
                    2,
                    this.state.unsubscribeLink
                  );
                  this.setState({ open4: false });
                  this.setState({ unsubscribeLink: "" });
                }}
              >
                Insert
              </div>
            </div>
          </div>
        )}
        {this.state.open8 && (
          <div
            className="modalPopupDelete"
            style={{
              top: "15%",
              width: "40vw",
              left: "45%",
              borderRadius: "10px",
              background: "var(--color-white, #FFF)",
              boxShadow: "4px 4px 10px 4px #DDD",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              padding: "20px",
              paddingBottom: "10px",
              zIndex: 200000,
            }}
          >
            <div className="modaltext">Insert Link</div>
            <div className="modalsubtext">
              Enter name for anchor tag
            </div>
            <TextField
              autoComplete="off"
              value={this.state.insertLinkName}
              onChange={(e) => {
                this.setState({ insertLinkName: e.target.value });
              }}
              variant="standard"
              placeholder="For example:click here"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "5px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: "37vw",
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div className="modalsubtext">
              Enter the actual URL you want to link to.
            </div>
            <TextField
              autoComplete="off"
              value={this.state.insertLink}
              onChange={(e) => {
                this.setState({ insertLink: e.target.value });
              }}
              variant="standard"
              placeholder="For example:https://coldsender.com"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: "37vw",
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  this.setState({ open8: false });
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                style={{
                  // opacity: this.state.insertLink === "" && 0.4,
                  pointerEvents: this.state.insertLink === "" && "none",
                }}
                onClick={() => {
                  this.buttonClick(
                    `https://app.coldsender.com/userclicked?userLinkId=userId&campaignLinkId=campaignId&nLinkstruct=node&tolinkmail=Email&userLinkToRedirect=${this.state.insertLink}&statergyLinkClick=stratergyLink`,
                    3,
                    this.state.insertLink
                  );

                  this.setState({ open8: false });
                  this.setState({ insertLink: "" });
                  this.setState({ insertLinkName: "" });
                }}
              >
                Insert
              </div>
            </div>
          </div>
        )}
        {this.state.open6 && (
          <Modal
            open={this.state.open6}
            onClose={() => {
              this.setState({ open6: false });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              className="modalPopupDelete"
              style={{
                top: "10%",
                left: "15%",
                width: "70vw",
                height: "80vh",
                overflowY: "scroll",
              }}
            >
              {this.props.emailBody}
            </div>
          </Modal>
        )}
        <ToastContainer />
        <Modal
          open={this.state.open2}
          onClose={() => {
            this.setState({ open2: false });
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete" style={{ top: "27%" }}>
            <div className="modaltext">Save as template</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                marginBottom: "6px",
                width: "100%",
              }}
            >
              <p
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                }}
              >
                Create email template
              </p>
              {this.test()}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                width: "100%",
              }}
            >
              <p
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                }}
              >
                Name
              </p>
              <input
                value={this.state.templateName}
                onChange={(e) => {
                  this.setState({ templateName: e.target.value });
                }}
                type="text"
                style={{
                  outline: "none",
                  padding: "8px",
                  flexGrow: 1,
                  backgroundColor: "transparent",
                  border: "1px solid #DDD",
                  borderRadius: "6px",
                  border: "1px solid #1C485F",
                }}
                placeholder="Enter something here..."
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  this.setState({ open2: false });
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  this.createTemplatetoFolder();
                }}
              >
                Save
              </div>
            </div>
          </div>
        </Modal>
        {/* {this.state.open3 && (
          <Modal
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.0)",
            }}
            open={this.state.open3}
            onClose={() => {
              this.setState({ open3: false });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              className="modalPopupDelete"
              style={{
                top: "59%",
                left: "73%",
                width: "23vw",
                borderRadius: "10px",
                background: "var(--color-white, #FFF)",
                boxShadow: "0px 2px 10px 0px rgba(25, 1, 52, 0.12)",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                padding: "0px",
                paddingBottom: "10px",
              }}
            >
              <div className="calendlymeethead">Available Calendly meeting</div>
              <div className="listcalendlybos">
                {this.state.calendlyData.length !== 0 &&
                  this.state.calendlyData.collection.map((val) => {
                    let dmUrl = val.scheduling_url;
                    return (
                      <>
                        {val.active && (
                          <>
                            <div className="insideboixcalend">
                              <div className="calendtexthead">{val.name}</div>
                              <div className="subheadcalendl">
                                {val.duration}mins /
                                {dmUrl.replace("https://calendly.com/", "")}
                              </div>
                            </div>
                            <div
                              className="inserlinkcALEND"
                              onClick={() => {
                                console.log("jrrkrkrkr");
                                this.buttonClick(
                                  val.scheduling_url,
                                  2,
                                  val.name
                                );
                              }}
                            >
                              Insert link
                            </div>
                          </>
                        )}
                      </>
                    );
                  })}
              </div>
            </div>
          </Modal>
        )} */}
      </div>
    );
  }
}

export default DrawerClassCampaign;
